export default function({ response }, commit, action) {
    const errors = response.data?.errors;
    for (let erro of errors) {
        commit(action, { alert: erro, type: "E" })
    }
}